<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Dự án: {{ modelData.name }}</h2>
        <div>
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="warning"
            size="small"
            @click="submitForm('createModel')">
            Cập nhật
          </el-button>
          <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="20">
          <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
            <el-form-item prop="image" label="Ảnh Dự án">
              <el-upload
                class="course-uploader"
                :action="upload.url"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="modelData.image_path" :src="modelData.image_path" class="course">
                <i v-else class="el-icon-plus course-uploader-icon"></i>
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh Dự án có dung lượng tối đa tải lên là 2Mb
                </div>
              </el-upload>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên Dự án" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="description" label="Mô tả ngắn" class="form-item">
                  <el-input v-model="modelData.description" :rows="8" type="textarea" class="input-seach"></el-input>
                </el-form-item>
                <el-form-item prop="big_description" label="Mời chào" class="form-item">
                  <el-input v-model="modelData.big_description" :rows="5" type="textarea" class="input-seach"></el-input>
                </el-form-item>
                <span>{{ modelData.link_view }}</span>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="priority" label="Độ ưu tiên" class="form-item">
                  <el-input v-model="modelData.priority" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="link" label="Link" class="form-item">
                  <el-input v-model="modelData.link" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="alt" label="Alt" class="form-item">
                  <el-input v-model="modelData.alt" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item prop="type" label="Type (2-Mobile)" class="form-item">
                  <el-input v-model="modelData.type" class="input-seach" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="content" label="Nội dung Dự án">
              <tinymce
                v-if="done"
                id="d1"
                v-model="modelData.content"
                :toolbar1="tinymce.toolbar1"
                :other_options="{ height: '500px',  images_upload_handler: handleImageAdded, language_url: '/static/plugins/tinymce/vi_VN.js' }"></tinymce>
            </el-form-item>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import ls from 'local-storage'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'ProjectUpdate',
  metaInfo () {
    return {
      title: 'Dự án | Thêm'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      done: false,
      modelData: {
        name: '',
        image: '',
        priority: '',
        description: '',
        big_description: '',
        alt: '',
        content: '',
        status: true
      },
      lists: {
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ],
        listUniversity: [
          {key: 0, value: 'Không thuộc trường nào'},
          {key: 1, value: 'Trường Học Viện Ngân Hàng'},
          {key: 2, value: 'Trường Kinh Tế Quốc Dân'}
        ]
      },
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'projects/upload',
        headers: {
          Authorization: ''
        }
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên clip' },
          { min: 2, max: 191, message: 'Tên clip có chiều dài từ 2 tới 191 kí tự' }
        ],
        price: [
          { required: true, message: 'Vui lòng nhập giá clip' },
          { type: 'number', message: 'Giá clip phải là kiểu số' }
        ],
        price_brick: [
          { required: true, message: 'Vui lòng nhập giá clip bị gạch' },
          { type: 'number', message: 'Giá clip bị gạch phải là kiểu số' }
        ],
        category_course_id: [
          { required: true, message: 'Vui lòng nhập lĩnh vực clip' }
        ],
        teacher_id: [
          { required: true, message: 'Vui lòng nhập giảng viên của clip' }
        ],
        image: [
          { required: true, message: 'Vui lòng upload ảnh của clip' }
        ],
        date_use: [
          { required: true, message: 'Vui lòng nhập số ngày sử dụng của clip' },
          { type: 'number', message: 'Số ngày sử dụng của clip phải là kiểu số' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.configUpload()
    this.fetchModel()
    // this.fetchListCategoryCourse()
    // this.fetchListUniversitiy()
    setTimeout(() => {
      this.done = true
    }, 1000)
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('projects/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'projects-index', text: 'Dự án' },
        { name: 'projects-create', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'projects-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('projects/' + this.$route.params.course_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực clip
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'system_manager': 0, 'user_type': 2}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về trường đại học
    fetchListUniversitiy () {
      axios.get('universities', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listUniversity = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.put('projects/' + this.$route.params.course_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'projects-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh clip có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.modelData.image = response.data.name
        this.modelData.image_path = response.data.path
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.course {
  width: 280px;
  height: 200px;
  display: block;
}
</style>

<style type="text/css">
.course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 280px;
  height: 200px;
  line-height: 200px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/Update.vue